module.exports = __webpack_public_path__ + "img/620.No_coffee_beans.0b65808f.svg";